import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faUserTie } from "@fortawesome/free-solid-svg-icons";

const BoardCv = ({ member, renderBody }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language.substring(0, 2);
  const body = lang === "en" ? member.body_en : member.body_it;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card board-cv-card border-0 shadow-sm rounded-4 mb-3 overflow-hidden bg-white">
      <button
        type="button"
        className="board-cv-toggle-btn d-flex align-items-center justify-content-between w-100 p-3 p-md-4 border-0 text-start"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={faUserTie} className="text-warning me-3 fs-5" />
          <h5 className="mb-0 fw-bold board-cv-name">{member.name}</h5>
        </div>
        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          className="board-cv-chevron ms-3 text-muted"
        />
      </button>

      {isOpen && (
        <div className="card-body px-4 pb-4 pt-3 border-top bg-light">
          <div className="subpage-text-content">
            {renderBody(body)}
          </div>
        </div>
      )}
    </div>
  );
};

export default BoardCv;
